import type {
  ExtractionCell,
  ExtractionClaim,
  ExtractionSourceLocation,
  ExtractionSourceSpan,
} from "@/features/data-curation/types";

/** A location of a Fast cell: an exact span of a passage, not cited lines. */
export const isSpanLocation = (location: ExtractionSourceLocation) =>
  Boolean(location.span) && !location.lines;

/** Whether the value of a cell comes from Fast spans, which are checked as exact text. */
export const isSpanCell = (cell: ExtractionCell) =>
  cell.source_locations.length > 0 && cell.source_locations.every(isSpanLocation);

export const isSpanClaim = (claim: ExtractionClaim) =>
  claim.source_locations.length > 0 && claim.source_locations.every(isSpanLocation);

/** The passage around a Fast value, with the exact span marked. */
export const SourceSpan = ({ span }: { span: ExtractionSourceSpan }) => {
  const begin = span.start - span.excerpt_start;
  const end = span.end - span.excerpt_start;
  return (
    <figure className="min-w-0">
      <figcaption className="text-zinc-500">{span.passage || "Passage"}</figcaption>
      <blockquote className="mt-1 whitespace-pre-wrap break-words leading-5 text-zinc-700">
        {span.excerpt_start > 0 && "…"}
        {span.excerpt.slice(0, begin)}
        <mark className="rounded-[2px] bg-amber-200 px-0.5 text-zinc-900">
          {span.excerpt.slice(begin, end)}
        </mark>
        {span.excerpt.slice(end)}
        {"…"}
      </blockquote>
    </figure>
  );
};
